<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <!-- dialog delete -->
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#ff618a"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false; type = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog update to approve -->
    <v-dialog v-model="dialog.aprove" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin mengaprove data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#ff618a"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="updates()">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.aprove = false; type = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div v-if="selectedPage === 'detail'">
          <div class="text-center">
            <v-avatar
              width="100" 
              height="100">
              <v-img 
                width="100" 
                height="100"
                :src="member.telegramDetail.image"
                @click="dialog.pic = true"
                class="mx-auto br-20 cursor-pointer">
              </v-img>
            </v-avatar>
          </div>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nama
              </p>
              {{member.telegramDetail.firstName}}
            </v-list-item-title>
          
            <v-list-item-title  
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
              Nama Pengguna
              </p>
              {{ member.telegramDetail.username }}
            </v-list-item-title>

            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
              Status
              </p>
              {{member.telegramStatus}}
            </v-list-item-title>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                small
                width="100"
                elevation="0"
                class="text-capitalize"
                 @click="reset(undefined, 'mobile'); selectedPage = 'detail'">
                Tutup
              </v-btn>
            </v-card-actions>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div class="my-5">
        <div class="title text--secondary">Data Telegram</div>
          <div class="caption text--secondary">{{pagination.totalData}} Pengguna Ditemukan</div>
          <v-skeleton-loader
             class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                 <v-list-item-avatar v-if="l.telegramDetail" @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer mr-3">
                  <v-img :src="l.telegramDetail.image"></v-img>
                </v-list-item-avatar>

                <v-list-item-content v-if="l.telegramDetail" @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2">
                  {{l.telegramDetail.firstName}}    
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="$vuetify.breakpoint.name !== 'xs' && l.telegramDetail"
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                    Nama
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs' && l.telegramDetail">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex">
                    <div>
                       {{l.telegramDetail.username}}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                    Nama Pengguna
                  </v-list-item-subtitle>
                </v-list-item-content>


                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex">
                    <div>
                      {{ l.telegramStatus }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                    Status
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="text-right">
                  <div>
                    <v-btn
                      fab
                      x-small
                      :disabled="l.telegramStatus === 'approved' || process.form"
                      color="#269B91"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      v-on:click="member = l; dialog.aprove = true">
                      <v-icon small>mdi-checkbox-marked-circle-outline</v-icon>
                    </v-btn>
                    <v-btn 
                      fab
                      x-small
                      :disabled="process.form"
                      color="red"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      @click="form.memberId=l.id; dialog.delete=true">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Pengguna"/>
          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2 font-weight-bold mt-4">Total {{ pagination.totalData }} data</div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#ff618a"
                    @input="fetch(page);showPage = false"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage">
          <div v-if="selectedPage === 'detail'">
            <div class="text-center">
              <v-avatar
                width="100" 
                height="100">
                <v-img 
                  width="100" 
                  height="100"
                  :src="member.telegramDetail.image"
                  @click="dialog.pic = true"
                  class="mx-auto br-20 cursor-pointer">
                </v-img>
              </v-avatar>
            </div>
            <div class="mt-10">
              <v-list-item-title
                class="body-2 grey--text text--darken-2">
                <p class="caption grey--text text-lighten-4 mb-1">
                  Nama
                </p>
                {{member.telegramDetail.firstName}}
              </v-list-item-title>
            
              <v-list-item-title  
                class="body-2 grey--text text--darken-2 mt-2">
                <p class="caption grey--text text-lighten-4 mb-1">
                Nama Pengguna
                </p>
                {{ member.telegramDetail.username }}
              </v-list-item-title>

              <v-list-item-title
                class="body-2 grey--text text--darken-2 mt-2">
                <p class="caption grey--text text-lighten-4 mb-1">
                Status
                </p>
                {{member.telegramStatus}}
              </v-list-item-title>
              <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  small
                  width="150"
                  class="text-capitalize"
                  @click="showPage = false">
                  Kembali
                </v-btn>
              </v-card-actions>
            </div>
          </div>
          </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import ImageInput from "../../../components/ImageInput.vue";
  import Empty from "../../../components/DataEmpty";
  export default {
    data() {
      return {
        option: {
          modules: {
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        dialog: {
          delete: false,
          aprove:false,
          form:false
        },
        showPage: false,
        selectedPage: "",
        filter: {
          username: ""
        },
        addImage:'',
        member: {},
        list: [],
        pagination: {},
        page: 1,
        avatar: null,
        form: {
          memberId:"",
        },
        process: {
          form: false,
          run: false
        },
        response: ""
      };
    },
    watch: {
      avatar: {
        handler: function () {
          this.form.memberImage = this.avatar ? this.avatar.url : ""
        },
        deep: true
      }
    },
    components: {
      ImageInput,
      Empty
    },
    computed: {},
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true;
        await get(`api/super/admin/telegram/list`, {
          params: {
            pagenum: p,
            limit: 10,
          }
        }).then(response => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      toDetail(item, status) {
        this.member = item
        this.selectedPage = "detail"
        this.showPage = status !== undefined ? false : true
        this.dialog.form = status !== undefined ? true : false
      },
      reset(item, status) {
        this.showPage = status !== undefined ? false : !this.showPage ? true : false

        this.avatar = item !== undefined ? {
          url: item.userUrlImg
        } : null

        this.form = {
          memberId: item !== undefined ? item.id : "",
        }
        this.dialog.form = status !== undefined ? !this.dialog.form ? true : false : false

        this.selectedPage = ''
        this.process.form = false

        this.response = ''
      },
       async save() {
        this.response = "";
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          if (this.form.memberId === "") {
            this.creates();
          } else {
            this.updates();
          }
        }
      },
      async updates() {
        this.process.form = true;
        await put(`api/super/admin/telegram/update/${this.member.id}`, {
        }).then(response => {
          let res = response.data;
          if (res.code === 201) {
            this.dialog.aprove = false
            this.fetch(this.page);
            this.showPage = false
            this.process.form = false
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async deletes(){
         this.process.form = true;
         await destroy(`api/super/admin/telegram/delete/${this.form.memberId}`).then((response) => {
           let res = response.data
           if(res.code == 201){
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.fetch()
           }else{
            this.process.form = false
            this.response = res.msg
           }
         })
      }
    }
  }
</script>

<style scoped>
.br-20 {
  border-radius: 20px;
}
</style>

